<template>
	<div
		class="mob-back-body"
		:class="{
			top60px: fromGuestjobdetails,
		}"
	>
		<div
			v-if="allProfileList && allProfileList.length"
			@click="showswicthprofile = !showswicthprofile"
			class="mob-apply-job-trans"
		>
			<div
				class="d-flex align-items-center fam-lato text-darkgrey fs-14 fw-LM w-90"
			>
				Applying Through:
				<div
					class="d-flex align-items-center fam-mont text-blue fs-13 fw-M w-61"
				>
					<img
						v-if="selectedProfile?.primary"
						class="mx-1"
						src="../../assets/newdesign/jobsearch/apply-primar-prof.svg"
						alt=""
					/>
					<img
						v-else
						class="mx-1"
						src="../../assets/newdesign/jobsearch/apply-prof.svg"
						alt=""
					/>
					<article class="w-90 text-truncate">
						{{ selectedProfile?.profileName }}
					</article>
				</div>
			</div>
			<img src="../../assets/newdesign/jobsearch/refresh.svg" alt="" />
		</div>
		<!-- <div
      style="
        position: fixed;
        top: 60px;
        z-index: 10000;
        left: 0px;
        backdrop-filter: blur(2px);
      "
      v-if="loader"
    >
      <Spinner />
    </div> -->
		<main class="h-100" :class="showswicthprofile ? 'card-blur' : ''">
			<div class="mobjd-applied-top for-job-form">
				<div class="mobjd-jobdetails">
					<FormShimmer
						v-if="shimmerLoader"
						:type="'mobile'"
						:shimmer="15"
						:from="'applyjob'"
					/>

					<b-row v-else>
						<b-col
							v-for="(field, index) in basicArray"
							:key="index"
							cols="12"
							class="relativeclass"
							:class="
								field.controlType == 'boolean'
									? 'd-flex align-items-center'
									: ''
							"
							v-show="!field.hide && field.key != 'source'"
						>
							<div
								v-if="
									field.controlType == 'text' ||
									field.controlType == 'email' ||
									field.controlType == 'number'
								"
								class="topDiv mt-3"
							>
								<InputField
									:type="field.controlType"
									:label="field.label"
									:mandatory="field.mandatory"
									:placeholder="field.placeholder"
									:id="field.key"
									:fieldType="field.fieldType"
									:vmodel="getCandidateData(field.key)"
									@select-value="updateFieldValue(field, $event)"
									@handle-input="handleInput(field)"
									@handle-blur="handleBlur(field)"
									:showError="getError(field)"
								/>
							</div>

							<div
								v-else-if="field.controlType == 'single_select'"
								class="topDiv mt-3"
							>
								<SelectCustom
									:label="field.label"
									:mandatory="field.mandatory"
									:placeholder="field.placeholder"
									:id="field.key"
									:vmodel="getCandidateData(field.key)"
									:api="field.apiEndpoint"
									:values="field.values"
									:dropdown="field.dropdown"
									:fieldType="field.fieldType"
									@select-value="updateFieldValue(field, $event)"
									:showError="getError(field)"
								/>
							</div>

							<div
								v-else-if="field.controlType == 'multi_select'"
								class="topDiv mt-3"
							>
								<MultiSelectCustom
									:label="field.label"
									:mandatory="field.mandatory"
									:placeholder="field.placeholder"
									:id="field.key"
									:api="field.apiEndpoint"
									:values="field.values"
									:dropdown="field.dropdown"
									:vmodel="getCandidateData(field.key)"
									:fieldType="field.fieldType"
									@select-value="updateFieldValue(field, $event)"
									:showError="getError(field)"
								/>
							</div>
							<div
								v-else-if="field.controlType == 'rich_text_box'"
								class="topDiv mt-3"
							>
								<CustomQuillEditor
									:type="field.controlType"
									:label="field.label"
									:mandatory="field.mandatory"
									:placeholder="field.placeholder"
									:id="field.key"
									:vmodel="getCandidateData(field.key)"
									@select-value="updateFieldValue(field, $event)"
									@handle-input="handleInput(field)"
									@handle-blur="handleBlur(field)"
									:showError="getError(field)"
								/>
							</div>
							<div
								v-else-if="field.controlType == 'boolean'"
								class="topDiv mt-4"
							>
								<SwitchBox
									:type="field.controlType"
									:label="field.label"
									:mandatory="field.mandatory"
									:placeholder="field.placeholder"
									:vmodel="getCandidateData(field.key)"
									:id="field.key"
									@select-value="updateFieldValue(field, $event)"
								/>
							</div>

							<div
								v-else-if="field.controlType == 'upload_file'"
								class="topDiv mt-3"
							>
								<UploadDocument
									:type="field.controlType"
									:label="field.label"
									:mandatory="field.mandatory"
									:placeholder="field.placeholder"
									:id="field.key"
									:vmodel="getCandidateData(field.key)"
									@select-value="updateFieldValue(field, $event)"
									:fileFormat="field.fileFormat"
									:showError="getError(field)"
									:maxFileSize="field.maxFileSize"
								/>
							</div>
							<div
								v-else-if="field.controlType == 'multi_text'"
								class="topDiv mt-3"
							>
								<FormTags
									:type="field.controlType"
									:label="field.label"
									:mandatory="field.mandatory"
									:placeholder="field.placeholder"
									:id="field.key"
									:suggestions="getSuggestions(field.key)"
									@select-value="updateFieldValue(field, $event)"
									:vmodel="getCandidateData(field.key)"
									:fileFormat="field.fileFormat"
									:showError="getError(field)"
									:maxFileSize="field.maxFileSize"
								/>
							</div>
							<div v-else-if="field.controlType == 'date'" class="topDiv mt-3">
								<DateField
									:type="field.controlType"
									:label="field.label"
									:mandatory="field.mandatory"
									:placeholder="field.placeholder"
									:id="field.key"
									:vmodel="getCandidateData(field.key)"
									@select-value="updateFieldValue(field, $event)"
									:showError="getError(field)"
									:format="field.dateTimeFormat"
								/>
							</div>

							<template v-if="touchedFields[field.key]">
								<div
									class="newInt-required-validation-font mt-1"
									v-if="field.mandatory && !validateField(field)"
								>
									{{ valText[field.key] }}
								</div>
								<div
									class="newInt-required-validation-font mt-1"
									v-else-if="field.limit > 0 && !validateField(field)"
								>
									{{ valText[field.key] }}
								</div>
							</template>
						</b-col>
					</b-row>

					<div
						class="d-flex align-items-center mt-4"
						v-if="advanceArray.length > 0"
					>
						<div @click="roundModalSvg = !roundModalSvg">
							<img
								v-if="roundModalSvg"
								src="../../assets/newdesign/inputcomponent/modalTopArrow.svg"
								alt=""
							/>
							<img
								v-else
								src="../../assets/newdesign/inputcomponent/modalDownArrow.svg"
								alt=""
							/>
						</div>
						<div class="cs-bluetxt ml-2 mr-3">Advanced</div>
						<div class="modal-horizontal-line"></div>
					</div>

					<b-row v-if="roundModalSvg">
						<b-col
							v-for="(field, index) in advanceArray"
							:key="index"
							cols="12"
							class="relativeclass"
							:class="
								field.controlType == 'boolean'
									? 'd-flex align-items-center'
									: ''
							"
							v-show="!field.hide"
						>
							<div
								v-if="
									field.controlType == 'text' ||
									field.controlType == 'email' ||
									field.controlType == 'number'
								"
								class="topDiv mt-3"
							>
								<InputField
									:type="field.controlType"
									:label="field.label"
									:mandatory="field.mandatory"
									:placeholder="field.placeholder"
									:id="field.key"
									:vmodel="getCandidateData(field.key)"
									@select-value="updateFieldValue(field, $event)"
									@handle-input="handleInput(field)"
									@handle-blur="handleBlur(field)"
									:showError="getError(field)"
								/>
							</div>

							<div
								v-else-if="field.controlType == 'single_select'"
								class="topDiv mt-3"
							>
								<SelectCustom
									:label="field.label"
									:mandatory="field.mandatory"
									:placeholder="field.placeholder"
									:id="field.key"
									:api="field.apiEndpoint"
									:values="field.values"
									:vmodel="getCandidateData(field.key)"
									:dropdown="field.dropdown"
									:fieldType="field.fieldType"
									@select-value="updateFieldValue(field, $event)"
									:showError="getError(field)"
								/>
							</div>

							<div
								v-else-if="field.controlType == 'multi_select'"
								class="topDiv mt-3"
							>
								<MultiSelectCustom
									:label="field.label"
									:mandatory="field.mandatory"
									:placeholder="field.placeholder"
									:id="field.key"
									:api="field.apiEndpoint"
									:values="field.values"
									:vmodel="getCandidateData(field.key)"
									:dropdown="field.dropdown"
									:fieldType="field.fieldType"
									@select-value="updateFieldValue(field, $event)"
									:showError="getError(field)"
								/>
							</div>
							<div
								v-else-if="field.controlType == 'rich_text_box'"
								class="topDiv mt-3"
							>
								<CustomQuillEditor
									:type="field.controlType"
									:label="field.label"
									:mandatory="field.mandatory"
									:placeholder="field.placeholder"
									:id="field.key"
									:vmodel="getCandidateData(field.key)"
									@select-value="updateFieldValue(field, $event)"
									@handle-input="handleInput(field)"
									@handle-blur="handleBlur(field)"
									:showError="getError(field)"
								/>
							</div>
							<div
								v-else-if="field.controlType == 'boolean'"
								class="topDiv mt-4"
							>
								<SwitchBox
									:type="field.controlType"
									:label="field.label"
									:mandatory="field.mandatory"
									:placeholder="field.placeholder"
									:vmodel="getCandidateData(field.key)"
									:id="field.key"
									@select-value="updateFieldValue(field, $event)"
								/>
							</div>

							<div
								v-else-if="field.controlType == 'upload_file'"
								class="topDiv mt-3"
							>
								<UploadDocument
									:type="field.controlType"
									:label="field.label"
									:mandatory="field.mandatory"
									:placeholder="field.placeholder"
									:id="field.key"
									:vmodel="getCandidateData(field.key)"
									@select-value="updateFieldValue(field, $event)"
									:fileFormat="field.fileFormat"
									:showError="getError(field)"
									:maxFileSize="field.maxFileSize"
								/>
							</div>
							<div
								v-else-if="field.controlType == 'multi_text'"
								class="topDiv mt-3"
							>
								<FormTags
									:type="field.controlType"
									:label="field.label"
									:mandatory="field.mandatory"
									:placeholder="field.placeholder"
									:id="field.key"
									:suggestions="getSuggestions(field.key)"
									@select-value="updateFieldValue(field, $event)"
									:vmodel="getCandidateData(field.key)"
									:fileFormat="field.fileFormat"
									:showError="getError(field)"
									:maxFileSize="field.maxFileSize"
								/>
							</div>
							<div v-else-if="field.controlType == 'date'" class="topDiv mt-3">
								<DateField
									:type="field.controlType"
									:label="field.label"
									:mandatory="field.mandatory"
									:placeholder="field.placeholder"
									:id="field.key"
									:vmodel="getCandidateData(field.key)"
									@select-value="updateFieldValue(field, $event)"
									:showError="getError(field)"
									:format="field.dateTimeFormat"
								/>
							</div>

							<template v-if="touchedFields[field.key]">
								<div
									class="newInt-required-validation-font mt-1"
									v-if="field.mandatory && !validateField(field)"
								>
									{{ valText[field.key] }}
								</div>
								<div
									class="newInt-required-validation-font mt-1"
									v-else-if="field.limit > 0 && !validateField(field)"
								>
									{{ valText[field.key] }}
								</div>
							</template>
						</b-col>
					</b-row>
				</div>
			</div>
			<div class="mobjd-applied-footer w-100 px-3">
				<div class="mob-cancelBtn w-50">
					<b-button class="w-100" @click="$emit('close')">Cancel</b-button>
				</div>
				<div class="mob-addBtn position-relative w-50">
					<b-button
						class="w-100"
						@click="validateForm"
						:class="
							buttonLoader ? 'loader-class-mobapply defaultCursor' : 'pointer'
						"
						:disabled="shimmerLoader || buttonLoader"
						>{{ buttonLoader ? "" : "Apply" }}</b-button
					>
					<div v-if="buttonLoader" class="loader-pos-new">
						<Loader />
					</div>
				</div>
			</div>
		</main>
		<Transition name="slidemob">
			<div class="filter-box-mob-2 h-unset" v-show="showswicthprofile">
				<img
					src="../../assets/newdesign/jobsearch/Profiles.svg"
					alt=""
					@click="showswicthprofile = false"
				/>
				<article class="switch-parent-radio">
					<SwitchProfile
						@selected-profile="updateSelectedProfile"
						@profile-list="updateProfileList"
						@switch-profile="switchProfile"
						@close-switch-profile="showswicthprofile = false"
					/>
				</article>
			</div>
		</Transition>
	</div>
</template>

<script>
import InputField from "../../components/InputComponents/Input.vue";
import SwitchBox from "../../components/InputComponents/Switch.vue";
import ExpertiseLevel from "@/components/InputComponents/ExpertiseLevel.vue";
import CustomQuillEditor from "../../components/InputComponents/CustomQuillEditor.vue";
import SelectCustom from "../../components/InputComponents/SelectCustom.vue";
import MultiSelectCustom from "../../components/InputComponents/MultiSelectCustom.vue";
import UploadDocument from "../../components/InputComponents/UploadDocument.vue";
import FormTags from "../../components/InputComponents/FormTags.vue";
import DateField from "../../components/InputComponents/DateField.vue";
// import Spinner from "../../components/fixedcomponents/Spinner.vue";
import SwitchProfile from "./SwitchProfile.vue";
import { getCandidateDetail } from "@/controllers/dashboard/asynchronous";
import {
	dynamicRules,
	getCustomFields,
	showError,
	validateField,
} from "../../utils/customField.js";
import {
	applyJob,
	getCandidateFilePaths,
	uploadJobDocuments,
} from "@/utils/apiFunctions";
import toast from "@/components/mixin/toast";
import { mapGetters } from "vuex";
import FormShimmer from "@/components/FormShimmer.vue";
import Loader from "@/components/fixedcomponents/Loader.vue";
import { trackJobApplied } from '@/utils/posthogHelpers';
const candidateDataMapping = {
	name: "fullName",
	experince: "totalYearsOfExp",
	currentLocation: "city",
	currentCTC: "currentCTC",
	expectedCTC: "expectedCTC",
	noticePeriod: "noticePeriod",
	altPhoneNumber: "altPhoneNumber",
	gender: "gender",
	email: "displayEmail",
	name: "fullName",
};

const suggestionsMapping = {
	skills: "skillName",
};

export default {
	name: "ApplyJob",
	mixins: [toast],
	props: {
		job: Object,
		licenseKey: [String, Number],
		fromGuestjobdetails: {
			type: Boolean,
			default: false,
		},
		// candidateData: Object,
	},
	data() {
		return {
			allProfileList: [],
			candidateData: {},
			loader: true,
			buttonLoader: false,
			showswicthprofile: false,
			resumePath: null,
			profileImagePath: null,
			roundModalSvg: true,
			shimmerLoader: false,
			advanceArray: [],
			basicArray: [],
			customFieldsArray: [],
			touchedFields: [],
			newObject: {},
			validations: {},
			valText: {},
			searchQuery: "",
			selected: null,
			localCandidateInfo: {},
			selectedProfile: {},
			showDropdown: false,
		};
	},
	components: {
		InputField,
		SwitchBox,
		CustomQuillEditor,
		SelectCustom,
		MultiSelectCustom,
		UploadDocument,
		FormTags,
		ExpertiseLevel,
		DateField,
		// Spinner,
		FormShimmer,
		Loader,
		SwitchProfile,
		// Spinner,
	},
	async created() {
		this.shimmerLoader = true;
		// await this.getCandidateFilePaths();
		// await this.initializeData();
	},
	computed: {
		...mapGetters("userVUEX", {
			userInfo: "getUserInfo",
		}),
	},
	methods: {
		updateSelectedProfile(profile) {
			0;
			if (!profile) return;
			this.selectedProfile = profile;
			this.selected = profile._id;
		},
		updateProfileList(profileList) {
			this.allProfileList = profileList;
		},

		async switchProfile(pId) {
			this.loader = true;
			this.basicArray = [];
			this.advanceArray = [];
			this.localCandidateInfo._id = pId;
			this.localCandidateInfo = await getCandidateDetail(this);
			this.$store.commit(
				"candidateVUEX/setCandidateInfo",
				this.localCandidateInfo
			);
			if (pId) {
				this.selectedProfile = this.allProfileList.find(
					(obj) => obj._id == pId
				);
				await this.getCandidateFilePaths(this.selectedProfile._id);
			}
			await this.initializeData();
			this.candidateData = this.localCandidateInfo;
			this.showDropdown = false;
			this.loader = false;
			this.shimmerLoader = false;
			this.showswicthprofile = false;
		},
		async initializeData() {
			this.shimmerLoader = true;
			try {
				const customFields = await getCustomFields("5", "add", this.licenseKey);

				if (customFields.length) {
					[this.customFieldsArray, this.newObject, this.touchedFields] =
						customFields;

					// Iterate through the original array and push objects into respective arrays based on category value
					this.customFieldsArray.forEach((obj) => {
						if (obj.category === 1 || obj.category === null) {
							this.basicArray.push(obj); // Push objects with category value 1 into category1Array
						} else if (obj.category === 2) {
							this.advanceArray.push(obj); // Push objects with category value 2 into category2Array
						}
					});

					this.validations = dynamicRules(this.customFieldsArray);
					this.shimmerLoader = false;
					this.loader = false;
				} else {
					throw new Error("Something went wrong");
				}
			} catch (error) {
				console.log(error);
				this.$emit("close");
			} finally {
				this.loader = false;
			}
		},
		async getCandidateFilePaths() {
			try {
				const res = await getCandidateFilePaths(this.selectedProfile._id);
				if (res.status == 200) {
					this.resumePath = res.data.data.resumePath;
					this.profileImagePath = res.data.data.profileImagePath;
				} else {
					throw new Error(res.data.data.Detail);
				}
			} catch (error) {
				console.error(error);
			}
		},
		validateForm() {
			let invalidForm = false;
			this.newObject["source"] = "other";
			this.newObject["otherSource"] = "Hire3x";
			for (let i = 0; i < this.customFieldsArray.length; i++) {
				const field = this.customFieldsArray[i];
				this.touchedFields[field.key] = true;
				this.$forceUpdate();
				if (!validateField(field, this)) {
					invalidForm = true;
				}
			}
			if (!invalidForm) {
				this.addCandidate();
			} else {
				this.errorModal("Error", "Please fill mandatory details");
			}
		},
		async addCandidate() {
			this.buttonLoader = true;
			try {
				let fieldsExceptUploadTypes;
				fieldsExceptUploadTypes = JSON.parse(JSON.stringify(this.newObject));
				for (const field of this.customFieldsArray) {
					if (field.controlType === "upload_file") {
						if (field.fieldType === "default") {
							delete fieldsExceptUploadTypes[field.key];
						} else {
							delete fieldsExceptUploadTypes.customFields[field.key];
						}
					}
				}
				if (typeof this.newObject.resume != "object") {
					fieldsExceptUploadTypes.resume = this.newObject["resume"];
				}
				const res = await applyJob({
					emailID: this.candidateData.email,
					jobID: this.job.jobID,
					firstName: this.candidateData.firstName,
					lastName: this.candidateData.lastName,
					location: this.candidateData.city,
					phoneNumber: this.candidateData.phoneNumber,
					candidateInfo: {
						...fieldsExceptUploadTypes,
						userID: this.userInfo.userID,
					},
				});
				if (res.status == 200) {
					const form = new FormData();
					var attachment = [];

					for (const field of this.customFieldsArray) {
						const value =
							field.fieldType === "default"
								? this.newObject[field.key]
								: this.newObject.customFields[field.key];
						if (
							field.controlType === "upload_file" &&
							value &&
							typeof value === "object"
						) {
							let obj = {
								attachmentName: field.key,
								fieldType: field.fieldType,
							};
							attachment.push(obj);
							form.append(field.key, value);
						}
					}
					form.append("attachment", JSON.stringify(attachment));
					form.append("jobID", this.job.jobID);
					form.append("licenseKey", this.job.licenseKey);
					form.append("email", this.candidateData.email);
					if (attachment.length) await uploadJobDocuments(form);
					trackJobApplied(this.job)
					this.$emit("success", this.job.jobID);
				} else {
					throw new Error(res.data.data.Detail);
				}
			} catch (error) {
				console.error(error);
				this.$emit("failure", error.message);
			} finally {
				this.buttonLoader = false;
			}
		},
		getCandidateData(key) {
			if (key === "resume") {
				if (!this.resumePath) return null;
				const data = { data: { uploadFile: this.resumePath } };
				return data;
			} else if (key === "imageMedia") {
				const data = { data: { uploadFile: this.profileImagePath } };
				return data;
			} else if (key == "skills") {
				if (!this.candidateData[key]) return null;
				return Object.values(this.candidateData[key]).map(
					(skill) => skill.skillName
				);
			}

			if (candidateDataMapping[key]) {
				if (key == "noticePeriod") {
					const value = this.candidateData[candidateDataMapping[key]];
					return value ? value.toLowerCase() : "";
				}
				return this.candidateData[candidateDataMapping[key]];
			} else {
				return this.candidateData[key] || null;
			}
		},
		getSuggestions(key) {
			let suggestions = [];
			if (candidateDataMapping[key]) {
				suggestions = this.candidateData[candidateDataMapping[key]];
			} else {
				suggestions = this.candidateData[key] || [];
			}

			if (suggestions.length) {
				if (typeof suggestions[0] !== "object") return suggestions;
				else if (typeof suggestions[0] === "object") {
					if (suggestionsMapping[key]) {
						return suggestions.map(
							(suggestion) => suggestion[suggestionsMapping[key]]
						);
					}
				}
			}

			return [];
		},
		toTitleCase(string) {
			if (!string) return "";
			return string
				.split(" ")
				.map((w) => (w[0] ? w[0].toUpperCase() + w.slice(1) : w))
				.join(" ");
		},
		getError(field) {
			console.log("the error", this.touchedFields[field.key]);
			return showError(field, this.touchedFields[field.key], this);
		},
		getVmodel(field) {
			console.log(this.newObject, this.newObject[field.key], field.key);
			return field.fieldType == "default"
				? this.newObject[field.key]
				: this.newObject.customFields[field.key];
		},
		handleInput(field) {
			console.log("the input value is", this.newObject[field.key]);
			this.touchedFields[field.key] = true;
			this.$forceUpdate();
		},
		handleBlur(field) {
			if (this.touchedFields[field.key] && !this.validations[field.key]) {
				validateField(field, this);
				this.$forceUpdate();
			}
		},
		updateFieldValue(field, value) {
			if (field.fieldType === "default") {
				this.$set(this.newObject, field.key, value);
			} else {
				this.$set(this.newObject.customFields, field.key, value);
			}
			if (
				(field.key === "source" || field.key === "noticePeriod") &&
				value === "other"
			) {
				if (field.category === 1 || field.category === null) {
					const selectedIndex = this.basicArray.findIndex(
						(option) => option.seq === field.seq && option.hide
					);
					this.basicArray[selectedIndex].hide = false;
				} else {
					const selectedIndex = this.advanceArray.findIndex(
						(option) => option.seq === field.seq && option.hide
					);
					this.advanceArray[selectedIndex].hide = false;
				}
			}
			this.$forceUpdate();
			validateField(field, this);
		},
		validateField(field) {
			return validateField(field, this);
		},
	},
};
</script>

<style>
.mob-apply-job-trans {
	background: linear-gradient(
		90deg,
		rgba(32, 99, 155, 0.15) 38.27%,
		rgba(173, 25, 39, 0.15) 100%
	);
	background-color: aliceblue;
	width: 100%;
	position: absolute;
	top: 0px;
	left: 0px;
	z-index: 21;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 8px 13px;
}
.for-job-form {
	margin-top: 33px;
	height: 86%;
}
.top60px {
	top: 60px;
}
</style>
